import React from "react";
import { useI18n } from "../../i18n/LanguageContext";
import "./LanguageSwitcher.css";

// Selector de idioma. Fijo arriba a la derecha, siempre accesible. Para añadir
// japonés basta con sumar { code: "ja", label: "日本語" } a esta lista.
const OPTIONS = [
  { code: "es", label: "ES" },
  { code: "en", label: "EN" },
];

export default function LanguageSwitcher() {
  const { lang, setLang } = useI18n();

  return (
    <div className="lang-switcher" role="group" aria-label="Idioma / Language">
      {OPTIONS.map((option) => (
        <button
          key={option.code}
          type="button"
          className={`lang-btn${lang === option.code ? " active" : ""}`}
          aria-pressed={lang === option.code}
          onClick={() => setLang(option.code)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
